export const dialogContactStyles = (theme) => ({
  button: {
    color: theme.palette.secondary.main,
  },
  bold: {
    fontSize: 15,
    marginTop: '-8px',
    fontWeight: '600',
    color: theme.palette.black,
  },
  iconBox: {
    textAlign: 'center',
    width: '100%',
    color: '#90b8b3',
  },
  icon: {
    fontSize: '44px',
  },
});
